export const CHANGE_PANEL_STATE = "CHANGE_PANEL_STATE";
export const CHANGE_ADD_MARKER_STATE = "CHANGE_ADD_MARKER_STATE";
export const CHANGE_CENTER_MAP = "CHANGE_CENTER_MAP";
export const CHANGE_ZOOM_MAP = "CHANGE_ZOOM_MAP";
